import { Title } from './Title'
import { Background } from './Background'
import { Man } from './Man'
import { Ingress } from './Ingress'
import { Ingress as IngressType } from '../../types'
import { MaxViewportRect } from './MaxViewportRect'
import * as style from './index.css'
import * as preact from 'preact'

const { h, Component } = preact

interface Props {
  ingress: IngressType;
  visible: boolean;
}

interface State {
  opacity: number;
  height: number;
  percentFinished: number;
}

export class Header extends Component<Props, State> {
  el: Element | null
  state = {
    opacity: 1,
    height: -1,
    percentFinished: 0
  }

  wrapper: Element

  componentDidMount() {
    if (this.props.visible) {
      requestAnimationFrame(this.update)
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
      this.update()
    }
  }

  update = () => {
    if (this.props.visible) {
      requestAnimationFrame(this.update)

      if (this.wrapper) {
        const { top, height } = this.wrapper.getBoundingClientRect()
        const percentFinished = -top / height
        this.setState({ percentFinished })
      }
    }
  }

  onViewportChange = height => {
    if (height !== this.state.height) {
      this.setState({ height })
    }
  }

  render() {
    const { ingress } = this.props
    const inlineStyle = { ['margin-top']: -this.state.height }
    return (
      <div
        class={style.header}
        ref={el => {
          this.wrapper = el
        }}
      >
        <MaxViewportRect onViewportChange={this.onViewportChange} />
        <Background height={this.state.height} percentFinished={this.state.percentFinished} />
        <div
          class={style.header__content}
          ref={el => {
            this.el = el
          }}
          style={inlineStyle}
        >
          <Ingress ingress={ingress} />
          <div className={style.titleWrapper}>
            <Man percentFinished={this.state.percentFinished} />
            <Title percentFinished={this.state.percentFinished} />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/v1/components/Header/index.tsx